import React from 'react';

const FormSelect = ({
    label,
    name,
    value,
    onChange,
    options = [],
    required = false,
    className = '',
    placeholder = '-- Select --',
    valueKey = 'value',
    labelKey = 'label',
    disabled = false,
    ...props
}) => {
    return (
        <div className={`col-12 ${className}`}>
            {label && (
                <label className="form-label text-secondary-light text-sm fw-medium mb-1">
                    {label} {required && <span className="text-danger">*</span>}
                </label>
            )}
            <select
                className="form-select radius-8 h-48-px"
                name={name}
                value={value}
                onChange={onChange}
                required={required}
                disabled={disabled}
                {...props}
            >
                <option value="">{placeholder}</option>
                {options.map((option, index) => (
                    <option key={index} value={option[valueKey]}>
                        {option[labelKey]}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default FormSelect;
